import { ColumnWidth, PATRON_STATUS, PatronType } from 'components/Dashboard/consts'
import { Button } from 'components/Button/Button'
import styles from './RowItem.module.scss'
import { v4 as uuidv4 } from 'uuid'
import classnames from 'classnames'
import { useIsMobile } from 'hooks/useIsMobile'
import { Icon } from 'components/Icon/Icon'


type Props = {
    patron: PatronType,
    columnWidth: ColumnWidth,
    onOpenWithdraw?: (patron: string | number) => void,
}

const MINIMAL_WIDTH = 1070

export function RowItem(props: Props) {
    const { screenWidth } = useIsMobile()

    function handleClickMobile() {
        if (screenWidth < MINIMAL_WIDTH) {
            console.log('mobile')
            props.onOpenWithdraw(props.patron.id)
        }
    }

    return (
        <div className={styles['wrapper']} onClick={handleClickMobile}>
            {Object.keys(props.patron).map((itemName) => {
                if (screenWidth < MINIMAL_WIDTH && !props.columnWidth[itemName].isMobile) {
                    return null
                }

                if (itemName === 'mobile' && screenWidth >= MINIMAL_WIDTH) {
                    return null
                }

                if (itemName === 'mobile' && screenWidth < MINIMAL_WIDTH) {
                    return (
                        <div
                            key={uuidv4()}
                            className={styles['btn']}
                            style={{ width: props.columnWidth[itemName].width }}
                            onClick={handleClickMobile}
                        >
                            <Icon name='arrow_right' />
                        </div>
                    )
                }

                if (itemName === 'action') {
                    return (
                        <div
                            key={uuidv4()}
                            className={styles['item']}
                            style={{ width: props.columnWidth[itemName].width }}
                        >
                            {props.patron['status'] === PATRON_STATUS.FAILED ? (
                                <Button
                                    size='xs'
                                    type='primary'
                                    stretch={false}
                                    onClick={() => props.onOpenWithdraw(props.patron.id)}
                                >
                                    Send again
                                </Button>
                            ) : (
                                <Button
                                    size='xs'
                                    type='border'
                                    stretch={false}
                                    onClick={() => props.onOpenWithdraw(props.patron.id)}
                                >
                                    Withdraw
                                </Button>
                            )}
                        </div>
                    )
                }

                if (itemName === 'status') {
                    const statusClassNames = classnames({
                        [styles['status']]: true,
                        [styles['status_green']]: props.patron[itemName] === PATRON_STATUS.WITHDREW,
                        [styles['status_blue']]: props.patron[itemName] === PATRON_STATUS.CLAIMED,
                        [styles['status_orange']]: props.patron[itemName] === PATRON_STATUS.UNCLAIMED,
                        [styles['status_red']]: props.patron[itemName] === PATRON_STATUS.FAILED,
                        [styles['status_gray']]: props.patron[itemName] === PATRON_STATUS.IN_PROGRESS,
                    })

                    return (
                        <div
                            key={uuidv4()}
                            className={styles['item']}
                            style={{ width: props.columnWidth[itemName].width }}
                        >
                            <div className={statusClassNames}>
                                {props.patron[itemName]}
                            </div>
                        </div>
                    )
                }

                return (
                    <div
                        key={uuidv4()}
                        className={styles['item']}
                        style={{ width: props.columnWidth[itemName].width }}
                    >
                        {props.patron[itemName]}
                    </div>
                )
            })}
        </div>
    );
}

